export default __webpack_public_path__ + "static/privacy_policy-39bfa1508ea7dc3df4f0601c506d92cd.pdf";